import { makeStyles } from '@material-ui/core';

import Logo from './LogoFull.svg';

const useStyles = makeStyles({
  svg: {
    width: 'auto',
    height: 45,
  },
});
const LogoFull = () => {
  const classes = useStyles();

  return <img alt="Logo" className={classes.svg} src={Logo} />;
};

export default LogoFull;
